import { ActivityStatus, SubTaskDTO } from '../common/Dtos';
import React from 'react';
import { STableCell, STableRow } from '../common/ScrivaniaTable';
import { SActivityStatus, SCheckbox } from '../common/BCommonComponents';
import { TextField } from '@material-ui/core';

interface SubRowProps {
	subTaskRow: SubTaskDTO;
	onRowChange: (subTask: SubTaskDTO, index: number) => void;
	onRowSelect: (subTask: SubTaskDTO) => void;
	isItemSelected: boolean;
	index: number;
	selected: string[];
	terminated: boolean;
	disabled: boolean;
}

export function SubTaskRow(props: SubRowProps) {
	const {subTaskRow, onRowChange, onRowSelect, isItemSelected, index, terminated, disabled} = props;

	const labelId = `subtask-${index}`;
	const textFieldsId = `note-${index}`;
	const subStatus = subTaskRow.status === ActivityStatus.OK ? "Esito Ok"
		: subTaskRow.status === ActivityStatus.WAIT ? "In Attesa"
			: subTaskRow.status === ActivityStatus.KO ? "Esito Ko" : "Indefinito";

	const handleClick = (event: React.MouseEvent<unknown>, subtask: SubTaskDTO) => {
		onRowSelect(subtask);
	};

	const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newSubTask: SubTaskDTO = {
			id: subTaskRow.id,
			nota: event.target.value,
			status: subTaskRow.status,
			description: subTaskRow.description
		}
		onRowChange(newSubTask, index);
	}

	return (
		<React.Fragment>
			<STableRow key={subTaskRow.id}
								 hover
								 role="checkbox"
								 aria-checked={isItemSelected}
								 tabIndex={-1}
								 selected={isItemSelected}
			>
				<STableCell padding="checkbox">
					<SCheckbox
						checked={isItemSelected}
						inputProps={{'aria-labelledby': labelId}}
						onClick={(event) => handleClick(event, subTaskRow)}
						disabled={terminated || disabled}
					/>
				</STableCell>
				<STableCell component="th" scope="row">{subTaskRow.description}</STableCell>
				<STableCell>
					<SActivityStatus status={subTaskRow.status}>{subStatus}</SActivityStatus>
				</STableCell>
				<STableCell>
					<TextField
						id={textFieldsId}
						multiline
						rows={2}
						variant="outlined"
						className="w-100"
						value={subTaskRow.nota}
						onChange={handleTextChange}
						disabled={terminated || disabled}
						InputLabelProps={{shrink: true}}
					/>
				</STableCell>
			</STableRow>
		</React.Fragment>
	)
}
